import {
  GET_MENU_NAMES,
  GET_MENU_STRUCT_BY_USER_ID,
  GET_SORTER_MENU_NAMES,
} from "../types";

const initialState = {
  menuStructByUserId: [],
  menuNames: [],
  sortedMenuNames: [],
};

export const roleControllerReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_MENU_STRUCT_BY_USER_ID: {
      return {
        ...state,
        menuStructByUserId: action.data,
      };
    }
    case GET_MENU_NAMES: {
      return {
        ...state,
        menuNames: action.data,
      };
    }
    case GET_SORTER_MENU_NAMES: {
      return {
        ...state,
        sortedMenuNames: action.data,
      };
    }
    default:
      return state;
  }
};
